import React from 'react';
import { Link } from 'react-router-dom';
interface LogoProps {
  className?: string;
  color?: string;
}
export const Logo: React.FC<LogoProps> = ({
  className = '',
  color
}) => {
  return <Link to="/" className={`inline-flex items-center ${className}`} data-id="element-828">
      <span className="text-xl md:text-2xl font-bold" data-id="element-829">
        <span className="text-primary" data-id="element-830">ZERO</span>
        <span className="text-gray-400 mx-1" data-id="element-831">|</span>
        <span className="text-primary" data-id="element-832">TO</span>
        <span className="text-gray-400 mx-1" data-id="element-833">|</span>
        <span className="text-primary" data-id="element-834">TEN</span>
      </span>
    </Link>;
};